import React, { useState, useEffect } from 'react';
import { Grid, Button, Box, Typography, useMediaQuery, Accordion, AccordionSummary, useTheme, AccordionDetails, Container, IconButton, Drawer, MenuItem, Divider } from '@mui/material';
import { useLanguage } from '../LanguageContext';
import { t } from '../utils/translationUtils';
import { useNavigate } from 'react-router-dom';
import translations from '../translations';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const Personal = () => {

  const navigate = useNavigate();
  const { language, switchLanguage } = useLanguage()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [goldExpanded, setGoldExpanded] = useState(false);
  const toggleLanguage = () => {
    switchLanguage(language === 'en' ? 'it' : 'en');
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  const handleImageClick = (imageName) => {
    const isAndroid = /android/i.test(navigator.userAgent);
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

    if (isMobile) {
      if (imageName === 'Home94' && isAndroid) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.cartareale.app&hl=en_NZ&gl=US&pli=1';
      } else if (imageName === 'Home93' && isIOS) {
        window.location.href = 'https://apps.apple.com/us/app/carta-reale/id6450711819';
      }
    }
  };

  const goldFeatures = [
    "Gold_Feature_1",
    "Gold_Feature_2",
    "Gold_Feature_3",
    "Gold_Feature_4",
    "Gold_Feature_5",
    "Gold_Feature_6",
    "Gold_Feature_7",
    "Gold_Feature_8",
    "Gold_Feature_9",
    "Gold_Feature_10",
    "Gold_Feature_11",
    "Gold_Feature_12",
    "Gold_Feature_13"
  ];

  const handleApriIlConto = () => {
    window.open('https://my.crhmoney.com/register', '_blank');
  };

  return (
    <>
      {/* Main container - add !important to override any parent styles */}
      <Box sx={{
        background: 'linear-gradient(135deg, #000000 0%, #354BA7 50%, #000000 100%) !important',
        color: '#ffffff',
        minHeight: '60vh',
        width: '100%',
        position: 'relative'
      }}>
        {/* Top navigation container */}
        <Box
          sx={{
            width: '100%',
            padding: '20px',
            backgroundColor: 'transparent !important', /* Force transparency */
            display: { xs: 'block', md: 'block', lg: 'block', xl: 'flex' }
          }}
        >
          {/* Logo container */}
          <Box sx={{
            width: { xs: '100%', xl: '50%' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent !important' /* Force transparency */
          }}>
 
            <img
              src="/images/logog.svg"
              alt={t("HomeNav1", translations, language)}
              style={{
                height: '200px',
                maxWidth: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>

          {/* Right half - Navigation and buttons */}
          <Box sx={{
            width: { xs: '100%', xl: '50%' },
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            gap: '20px',
            justifyContent: 'center',
            alignItems: 'center',
            mt: { md: 3, xl: 0 }  // Add margin-top when in stacked layout
          }}>
            {/* Top row - Account, Access, Language */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '30px'
            }}>
              {/* Open Account */}
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleApriIlConto}>
                <img src="/images/Navbar2.webp" alt="Open Account" style={{ width: '70px', marginRight: '12px' }} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                    color: '#FFFFFF'
                  }}
                >
                  {t("HomeNav2", translations, language)}
                </Typography>
              </Box>

              {/* Client Access */}
              <Box
                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => window.open('https://my.crhmoney.com', '_blank')}
              >
                <img src="/images/Navbar3.webp" alt="Client Access" style={{ width: '70px', marginRight: '12px' }} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                    color: '#FFFFFF'
                  }}
                >
                  {t("HomeNav3", translations, language)}
                </Typography>
              </Box>

              {/* Language Selector */}
              <Box
                onClick={() => switchLanguage(language === 'en' ? 'it' : 'en')}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {language === 'en' ? (
                  <img src="/images/Usa.svg" alt="English" style={{ width: '36px' }} />
                ) : (
                  <img src="/images/Ita.svg" alt="Italian" style={{ width: '36px' }} />
                )}
              </Box>
            </Box>

            {/* Bottom row - Navigation buttons */}
            <Box sx={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center'
            }}>
              <Button
                onClick={() => navigate('/')}
                sx={{
                  color: '#FFFFFF',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' }
                }}
              >
                {t("HomeNav4", translations, language)}
              </Button>

              <Button
                sx={{
                  backgroundColor: '#ffffff',
                  color: '#000000',
                  borderRadius: '30px',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#ffffff' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' }
                }}
              >
                {t("HomeNav5", translations, language)}
              </Button>

              <Button
                onClick={() => navigate('/Business')}
                sx={{
                  color: '#FFFFFF',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' }
                }}
              >
                {t("HomeNav6", translations, language)}
              </Button>

              <Button
                onClick={() => navigate('/contact_us')}
                sx={{
                  color: '#FFFFFF',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                  borderRadius: '30px'
                }}
              >
                {t("Contatti", translations, language)}
              </Button>
            </Box>
          </Box>
          {/* Mobile Menu Button - Only visible on mobile */}
          <Box sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'flex-end',
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: 1300  // Higher z-index to ensure it's above everything
          }}>
            <IconButton
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              sx={{
                color:'#FFFFFF',
                padding: '12px'
              }}
            >
              <MenuIcon fontSize="large" />
            </IconButton>
          </Box>

          {/* Mobile Menu Drawer */}
          <Drawer
            anchor="right"
            open={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
            sx={{
              display: { xs: 'block', md: 'none' },
              '& .MuiDrawer-paper': {
                width: '100%',
                backgroundColor: '#000000',
                color: '#ffffff',
              }
            }}
          >
            <Box sx={{ p: 2 }}>
              {/* Header with back button */}
              <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
                <IconButton
                  onClick={() => setMobileMenuOpen(false)}
                  sx={{ ml: 1, color: '#FFFFFF' }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" sx={{ ml: 2, color: '#FFFFFF' }}>
                  Menu
                </Typography>
              </Box>
              <Divider sx={{ backgroundColor: '#FFFFFF' }} />

              {/* Menu Items */}
              <Box sx={{ py: 2 }}>
                {/* Home */}
                <MenuItem
                  onClick={() => {
                    navigate('/');
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                  }}
                >
                  {t("HomeNav4", translations, language)}
                </MenuItem>

                {/* Personal */}
                <MenuItem
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                    backgroundColor: '#333333',
                  }}
                >
                  {t("HomeNav5", translations, language)}
                </MenuItem>

                {/* Business */}
                <MenuItem
                  onClick={() => {
                    navigate('/business');
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                  }}
                >
                  {t("HomeNav6", translations, language)}
                </MenuItem>

                <Divider sx={{ backgroundColor: '#FFFFFF', my: 1 }} />

                {/* Open Account */}
                <MenuItem
                  onClick={() => {
                    handleApriIlConto();
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                  }}
                >
                  {t("HomeNav2", translations, language)}
                </MenuItem>

                {/* Client Access */}
                <MenuItem
                  onClick={() => {
                    window.open('https://my.crhmoney.com', '_blank');
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                  }}
                >
                  {t("HomeNav3", translations, language)}
                </MenuItem>

                {/* Contact Us */}
                <MenuItem
                  onClick={() => {
                    navigate('/contact_us');
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '400',
                    whiteSpace: 'nowrap',
                    py: 1,
                  }}
                >
                  {t("Contatti", translations, language)}
                </MenuItem>

                <Divider sx={{ backgroundColor: '#FFFFFF', my: 1 }} />

                {/* Language Toggle */}
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                  <IconButton
                    onClick={() => {
                      switchLanguage(language === 'en' ? 'it' : 'en');
                      setMobileMenuOpen(false);
                    }}
                    sx={{ p: 1, color: '#FFFFFF' }}
                  >
                    {language === 'en' ? (
                      <img src="/images/Usa.svg" alt="English" style={{ width: '36px' }} />
                    ) : (
                      <img src="/images/Ita.svg" alt="Italian" style={{ width: '36px' }} />
                    )}
                  </IconButton>
                </Box>
              </Box>
            </Box>
          </Drawer>
        </Box>


        <Box>
          <Grid container>
            {/* Left side with picture */}
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                display: { xs: 'none', sm: 'none', md: 'flex' }, 
                justifyContent: 'center',
                alignItems: 'center',
                pt: { xs: '2rem', sm: '2rem', md: '4rem', lg: '5rem' },
              }}
            >
              <Box
                sx={{
                  width: { xs: '80%', sm: '70%', md: '80%', lg: '80%' },
                  height: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src="/images/cubo.webp"
                  alt="CRH Money Cube"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '35px',

                  }}
                />
              </Box>
            </Grid>

            {/* Right side with text */}
            
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                pr: { xs: '1rem', sm: '2rem', md: '2rem', lg: '2rem' },
                pl: { xs: '1rem', sm: '2rem', md: '4rem', lg: '6rem' },
                pt: { xs: '2rem', sm: '3rem', md: '4rem', lg: '0rem' },
                pb: { xs: '2rem', sm: '3rem', md: '4rem', lg: '10rem' },
              }}
            >
              <Box className="HomeBox1" sx={{ maxWidth: '620px' }}>
                <Typography
                  variant="h1"
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 700,
                    fontSize: { xs: '36px', sm: '42px', md: '48px', lg: '48px' },
                    color: '#FFFFFF',
                    mb: { xs: 2, sm: 3, md: 4, lg: 5 },
                    lineHeight: 1.2,
                  }}
                >
                  {t("Personal1", translations, language)}
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '16px', sm: '20px', md: '24px', lg: '24px' },
                    color: '#FFFFFF',
                    mb: { xs: 2, sm: 3, md: 4, lg: 5 },
                  }}
                >
                  {t("Personal2", translations, language)}
                </Typography>


                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 700,
                    fontSize: { xs: '16px', sm: '20px', md: '24px', lg: '24px' },
                    color: '#FFFFFF',
                    mb: { xs: 2, sm: 3, md: 4, lg: 5 },
                    width: '100%',
                  }}
                >
                  {t("Personal3", translations, language)}
                </Typography>

                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <Button
                    component="a"
                    onClick={handleApriIlConto}
                    variant="contained"
                    sx={{
                      backgroundColor: '#F7CE5F', // Rosso Savoia from color palette
                      color: '#000000',
                      borderRadius: '35px',
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      fontSize: { xs: '16px', sm: '16px', md: '20px', lg: '24px' },
                      padding: '10px 30px',
                      textTransform: 'uppercase',
                      '&:hover': { backgroundColor: '#9e2420' },

                    }}
                  >
                    {t("homeBox1_button", translations, language)}
                  </Button>
                </Box>
              </Box>
            </Grid>

          </Grid>
        </Box>
      </Box>




{/* White background section with cards - complete code */}
<Box sx={{ 
  width: '100%',
  bgcolor: 'white',
  py: { xs: 4, md: 4 }, // Reduced padding
  overflow: 'hidden', // Ensure no horizontal scrolling
  display: 'flex', // Added flex display
  flexDirection: 'column', // Column layout
  alignItems: 'center', // Center horizontally
  mb: 15,
  mt: 3
}}>
  {/* Section header */}
  <Box sx={{ textAlign: 'center', mb: { xs: 2, md: 2 }, px: 2 }}> {/* Reduced margin bottom */}
    <Typography 
      variant="h2" 
      sx={{ 
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontSize: { xs: '32px', sm: '40px', md: '48px' },
        color: 'black',
        mb: 3,
        mt: 3
      }}
    >
      {t("Personal_Cards_Title", translations, language)}
    </Typography>
    
    <Typography 
      variant="h5" 
      sx={{ 
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: { xs: '16px', sm: '20px', md: '24px' },
        color: 'black',
        maxWidth: '800px',
        mx: 'auto',
        mt: 1
      }}
    >
      {t("Personal_Cards_Subtitle", translations, language)}
    </Typography>
  </Box>
  
  {/* Cards wrapper - with absolute positioning */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'center',
      alignItems: 'flex-start', // Align to top explicitly
      gap: { xs: 4, md: 4 },
      px: 2,
      mx: 'auto',
      maxWidth: { md: '1800px' },
      mt: { xs: 0, md: 30 }, // Negative margin to move up
      position: 'relative', // Important for positioning context
      width: '100%',
      alignSelf: 'flex-start' // Force align to top of parent
    }}
  >
    {/* Gold Card */}
    <Box
      sx={{
        width: { xs: '100%', md: '700px' },
        maxWidth: { xs: '550px', md: '500px' },
        position: 'relative',
        mb: { xs: 6, md: 0 },
        mx: 'auto',
        alignSelf: 'flex-start' // Force align to top
      }}
    >
      {/* Card image positioned to overlap - desktop only */}
      <Box 
        sx={{ 
          position: 'absolute',
          top: { md: '-220px' }, // Positioned even higher
          left: '50%',
          transform: 'translateX(-50%)',
          width: { md: '95%' },
          maxWidth: '650px',
          zIndex: 2,
          display: { xs: 'none', md: 'block' },
          textAlign: 'center'
        }}
      >
        <img 
          src="/images/CardGold.webp" 
          alt="CRH Gold Card"
          style={{
            width: '100%',
            
          }}
        />
      </Box>
      
      <Box sx={{ 
        position: 'relative',
        zIndex: 1,
        width: '100%',
        height: { md: goldExpanded ? 'auto' : '500px' } // Set fixed height when closed
      }}>
        {/* Main card */}
        <Box sx={{ 
          bgcolor: '#354BA7', 
          borderRadius: goldExpanded ? '35px 35px 0 0' : '35px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: { xs: 4, md: 5 },
          pt: { xs: 4, md: '170px' }, // Reduced padding top
          position: 'relative',
          width: '100%',
          height: { md: goldExpanded ? 'auto' : '500px' } // Match height with other card
        }}>
          {/* Card image - mobile only */}
          <Box sx={{ 
            mb: 4, 
            mt: 2, 
            textAlign: 'center',
            display: { xs: 'block', md: 'none' }
          }}>
            <img 
              src="/images/CardGold.webp" 
              alt="CRH Gold Card"
              style={{
                width: '100%',
                maxWidth: '400px',
                
              }}
            />
          </Box>
          
          {/* Card title */}
          <Typography 
            variant="h3" 
            sx={{ 
              fontFamily: 'Poppins',
              fontWeight: 700,
              fontSize: { xs: '32px', md: '48px' },
              color: 'white',
              mb: 2
            }}
          >
            {t("Personal_Gold_Title", translations, language)}
          </Typography>
          
          {/* Card description */}
          <Typography 
            variant="body1" 
            sx={{ 
              fontFamily: 'Poppins',
              fontWeight: 400,
              fontSize: { xs: '18px', md: '24px' },
              color: 'white',
              mb: 4,
              textAlign: 'center'
            }}
          >
            {t("Personal_Gold_Description", translations, language)}
          </Typography>
          
          {/* Button with red text */}
          <Button
            variant="contained"
            sx={{
              bgcolor: 'white',
              color: '#BB2E25',
              borderRadius: '35px',
              px: 4,
              py: 1.5,
              fontFamily: 'Poppins',
              fontWeight: 700,
              fontSize: { xs: '12px', sm: '16px', md: '24px' }, 
              textTransform: 'uppercase',
              '&:hover': { bgcolor: '#f0f0f0' },
              mb: 3
            }}
            onClick={handleApriIlConto}
          >
            {t("Personal_Gold_Button", translations, language)}
          </Button>
          
          {/* Down arrow icon - only for Gold card */}
          <Box 
            sx={{ 
              mt: 'auto', 
              mb: 1, 
              color: 'white',
              cursor: 'pointer'
            }}
            onClick={() => setGoldExpanded(!goldExpanded)}
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10l5 5 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Box>
        </Box>
        
        {/* Expandable section for Gold card */}
        {goldExpanded && (
          <Box sx={{ 
            bgcolor: '#D4B78E', 
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
            width: '100%',
            pb: 2,
            position: 'relative',
            zIndex: 0
          }}>
            {/* List of features */}
            {goldFeatures.map((feature, index) => (
              <Box key={index} sx={{
                borderBottom: index < goldFeatures.length - 1 ? '1px solid rgba(0,0,0,0.2)' : 'none',
                py: 1.5,
                px: 3,
                textAlign: 'center'
              }}>
                <Typography 
                  sx={{ 
                    fontFamily: 'Poppins',
                    fontSize: { xs: '18px', md: '24px' },
                    fontWeight: index === 0 ? 600 : 400,
                    color: '#000000'
                  }}
                >
                  {t(feature, translations, language)}
                </Typography>
              </Box>
            ))}
            
            {/* Up arrow at bottom */}
            <Box 
              sx={{ 
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                cursor: 'pointer'
              }}
              onClick={() => setGoldExpanded(false)}
            >
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 14l5 -5 5 5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
    
    {/* Reserve Card */}
    <Box
      sx={{
        width: { xs: '100%', md: '700px' },
        maxWidth: { xs: '550px', md: '500px' },
        position: 'relative',
        mx: 'auto',
        alignSelf: 'flex-start' // Force align to top
      }}
    >
      {/* Card image positioned to overlap - desktop only */}
      <Box 
        sx={{ 
          position: 'absolute',
          top: { md: '-220px' }, // Positioned even higher
          left: '50%',
          transform: 'translateX(-50%)',
          width: { md: '95%' },
          maxWidth: '650px',
          zIndex: 2,
          display: { xs: 'none', md: 'block' },
          textAlign: 'center'
        }}
      >
        <img 
          src="/images/CardBlack.webp" 
          alt="CRH Reserve Card"
          style={{
            width: '100%',
           
          }}
        />
      </Box>
      
      <Box sx={{ 
        bgcolor: '#354BA7', 
        borderRadius: '35px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: { xs: 4, md: 5 },
        pt: { xs: 4, md: '170px' }, // Reduced padding top
        position: 'relative',
        height: { md: '500px' }, // Fixed height to match Gold card
        width: '100%'
      }}>
        {/* Card image - mobile only */}
        <Box sx={{ 
          mb: 4, 
          mt: 2, 
          textAlign: 'center',
          display: { xs: 'block', md: 'none' }
        }}>
          <img 
            src="/images/CardBlack.webp" 
            alt="CRH Reserve Card"
            style={{
              width: '100%',
              maxWidth: '400px',
              
            }}
          />
        </Box>
        
        {/* Card title */}
        <Typography 
          variant="h3" 
          sx={{ 
            fontFamily: 'Poppins',
            fontWeight: 700,
            fontSize: { xs: '32px', md: '48px' },
            color: 'white',
            mt: 4,
            mb: 8
          }}
        >
          {t("Personal_Reserve_Title", translations, language)}
        </Typography>
        
        {/* Card description */}
        
        
        {/* Button with red text */}
        <Button
          variant="contained"
          sx={{
            bgcolor: 'white',
            color: '#BB2E25',
            borderRadius: '35px',
            px: 4,
            py: 1.5,
            fontFamily: 'Poppins',
            fontWeight: 700,
            fontSize: { xs: '12px', sm: '16px', md: '24px' }, // Responsive font size
            textTransform: 'uppercase',
            '&:hover': { bgcolor: '#f0f0f0' },
            mb: 3,
            mt: 'auto' // Push button to bottom to match height
          }}
        >
          {t("Personal_Reserve_Button", translations, language)}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>

    </>
  );
};

export default Personal;